import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { StyledEngineProvider } from '@mui/material/styles';

// Suppress ResizeObserver errors (harmless warning from browser)
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
    e.preventDefault();
    return;
  }
});

// Also suppress unhandled promise rejections for ResizeObserver
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver')) {
    e.preventDefault();
    return;
  }
});

// Additional suppression for React error overlay
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    return;
  }
  originalError.apply(console, args);
};

// Registrera service worker INNAN React mountar så att 'load' event kan fångas
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('Service worker update detected');
    // Anropa callback från UpdateNotification om den finns
    if ((window as any).__SW_UPDATE_CALLBACK__) {
      (window as any).__SW_UPDATE_CALLBACK__(registration);
    }
  },
  onSuccess: (registration) => {
    console.log('Service worker registered successfully:', registration?.active?.scriptURL);
  }
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
    <App />
    </StyledEngineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
